import {register} from '@shopify/theme-sections';

const selectors = {
  writeReviewContainer: '[data-bv-show="inpage_submission"]',
  termsAndConditionsLabel: '#agreement-termsAndConditions > span',
  reviewsContainer: '[data-bv-show="reviews"]',
  locale: [
    // Mobile Locale
    ':has(> select > option[value="English"])',
    // Desktop Locale
    ':has(> [aria-controls="bv-reviews-filter-Locale"])',
  ],
  media: [
    // Media Slider
    '#bv_review_maincontainer :has(> h3):has(.photos-tile)',
    // Skeleton Media
    '#bv_review_maincontainer .eYyiQm',
    // Reviews Media
    '[data-bv-v="contentSummary"] > :has(.photos-tile)',
  ],
};

export default register('bazaar-voice-reviews', {
  onLoad() {
    this.injectReviewsStyles();
    this.injectWriteReviewContent();
  },

  injectReviewsStyles() {
    const reviewsContainer = this.container.querySelector(selectors.reviewsContainer);
    if (!reviewsContainer) return;

    const observer = new MutationObserver(() => {
      if (!reviewsContainer.shadowRoot) return;

      const styleSheet = new CSSStyleSheet();
      styleSheet.insertRule(`
        ${selectors.locale.join(',')},${selectors.media.join(',')}  {
          display: none;
        }
      `);

      reviewsContainer.shadowRoot.adoptedStyleSheets.push(styleSheet);
      observer.disconnect();
    });

    observer.observe(reviewsContainer, {childList: true, subtree: true, attributes: true});
  },

  injectWriteReviewContent() {
    const documentObserver = new MutationObserver(() => {
      const writeReviewContainer = document.querySelector(selectors.writeReviewContainer);
      if (!writeReviewContainer?.shadowRoot) return;

      const observer = new MutationObserver(() => {
        const termsAndConditionsLabel = writeReviewContainer.shadowRoot.querySelector(
          selectors.termsAndConditionsLabel,
        );
        if (!termsAndConditionsLabel) return;

        // Add privacy policy text
        const privacyPolicyContent = document.createElement('span');
        privacyPolicyContent.textContent = ' and use of my personal information in accordance with slip’s ';

        // Add privacy policy link
        const privacyPolicyLink = document.createElement('a');
        privacyPolicyLink.href = '/pages/privacy-policy';
        privacyPolicyLink.target = '_blank';
        privacyPolicyLink.classList.add('bv-text-link', 'bv-focusable');
        privacyPolicyLink.textContent = 'privacy policy';
        privacyPolicyLink.style.textDecoration = 'underline';

        // Prevent BV modal behaviour
        privacyPolicyLink.addEventListener('click', (event) => {
          event.preventDefault();
          window.open('/pages/privacy-policy', '_blank');
          event.stopPropagation();
        });

        // Add privacy policy content to terms and conditions label
        privacyPolicyContent.appendChild(privacyPolicyLink);
        termsAndConditionsLabel.appendChild(privacyPolicyContent);

        observer.disconnect();
        documentObserver.disconnect();
      });

      observer.observe(writeReviewContainer.shadowRoot, {childList: true, subtree: true, attributes: true});
    });

    documentObserver.observe(document, {childList: true, subtree: true});
  },
});
